/*
  ! This file exists temporarily as we migrate to using ES modules
  ! Do not add new dependencies here unless necessary
  ! Instead, import them as needed within the files where they are used
*/

import 'jquery';
import '@uirouter/angularjs';
import '@uirouter/angularjs/release/stateEvents';
import 'angular-ui-bootstrap';
import 'ui-select';
import 'javascript-detect-element-resize';
import 'angular-ui-grid';
import 'angular-ui-mask';

import 'angular-hotkeys';
import 'angular-clipboard';
import 'angular-animate';
import 'angular-gridster';
import 'angular-growl-v2';
import 'angular-json-human';
import '@petrocloud/angular-sails/angular-sails';
import 'angular-sanitize';
import 'big.js';
import 'lodash';
import 'ng-table/bundles/ng-table'; // https://github.com/esvit/ng-table/issues/969
import 'angular-cron-jobs';
import 'angular-filter';
import 'angular-ui-tree';
import 'angular-dayparts/dist/angular-dayparts.js';
// TODO: Fix me
import saveAs from 'file-saver'; // eslint-disable-line no-unused-vars
import 'angular-vs-repeat';
import SlidingMarker from 'marker-animate-unobtrusive';
window.SlidingMarker = SlidingMarker;
import { InfoBox } from 'google-maps-infobox';
window.InfoBox = InfoBox;
import markerWithLabel from 'markerwithlabel';
window.MarkerWithLabel = markerWithLabel(google.maps);

export default [
  'ui.router',
  'ui.router.state.events', // Polyfill TODO: Replace route change listeners with $transition
  'ngAnimate',
  'ngSanitize',
  'ngSails',
  'ngTable',
  'ui.bootstrap',
  'angular-growl',
  'gridster',
  'yaru22.jsonHuman',
  'angular-cron-jobs',
  'ui.grid',
  'ui.mask',
  'ui.grid.autoResize',
  'ui.grid.selection',
  'ui.grid.edit',
  'ui.grid.resizeColumns',
  'ui.grid.pagination',
  'ui.grid.exporter',
  'ui.grid.expandable',
  'ui.grid.pinning',
  'ui.grid.saveState',
  'ui.grid.moveColumns',
  'angular.filter',
  'angular-dayparts',
  'ui.tree',
  'ui.select',
  'angular-clipboard',
  'cfp.hotkeys',
  'vs-repeat',
];
